import React from 'react';
interface BrandMarkProps {
  className?: string;
  size?: number;
}
/**
 * Blinkblis brand mark — premium vector treatment.
 * Inspired by the brushstroke ring + gold serif B logo.
 * 100% transparent, scales cleanly from favicon (16px) to display (200px+).
 */
export function BrandMark({
  className = '',
  size
}: BrandMarkProps) {
  return <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1">
      <defs data-id="element-2">
        {/* Multi-stop gradient matching the actual logo: navy → teal → emerald */}
        <linearGradient id="bb-brushstroke" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse" data-id="element-3">
          <stop offset="0%" stopColor="#0F2747" data-id="element-4" />
          <stop offset="35%" stopColor="#0E5C66" data-id="element-5" />
          <stop offset="70%" stopColor="#136B47" data-id="element-6" />
          <stop offset="100%" stopColor="#1FA971" data-id="element-7" />
        </linearGradient>

        {/* Inner subtle radial highlight on the ring for depth */}
        <radialGradient id="bb-inner-glow" cx="32" cy="32" r="26" gradientUnits="userSpaceOnUse" data-id="element-8">
          <stop offset="60%" stopColor="#0F2747" stopOpacity="0" data-id="element-9" />
          <stop offset="100%" stopColor="#0F2747" stopOpacity="0.08" data-id="element-10" />
        </radialGradient>
      </defs>

      {/* Brushstroke ring — thicker, with intentional gap */}
      <circle cx="32" cy="32" r="26" stroke="url(#bb-brushstroke)" strokeWidth="5" strokeLinecap="round" strokeDasharray="142 22" transform="rotate(-42 32 32)" data-id="element-11" />

      {/* Subtle depth glow */}
      <circle cx="32" cy="32" r="23" fill="url(#bb-inner-glow)" data-id="element-12" />

      {/* Two gold accent dots flanking the B (horizontal axis) */}
      <circle cx="14" cy="32" r="1.6" fill="#D6B25E" data-id="element-13" />
      <circle cx="50" cy="32" r="1.6" fill="#D6B25E" data-id="element-14" />

      {/* Gold serif B — the heart of the mark */}
      <text x="32" y="43" fontFamily="Fraunces, 'Times New Roman', Georgia, serif" fontSize="32" fontWeight="700" fill="#D6B25E" textAnchor="middle" letterSpacing="-0.5" data-id="element-15">
        B
      </text>
    </svg>;
}